import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {DynamicModalLoaderService} from '../../../../layout/services/dynamic-modal-loader.service';
import {Subject, Subscription} from 'rxjs';
import {NavicanSampleFormComponent} from './navican-sample-form/navican-sample-form.component';
import {TestActionsService} from '../../../../dashboard/test/services/test-actions.service';
import {PlaceholderModalComponent} from '../../../../layout/components/modals/placeholder-modal/placeholder-modal.component';
import {modalResponse} from '../../../../layout/constants/modal-responses.enum';
import {CoreActionCreatorService} from '../../../../core/services/core-action-creator.service';
import {TestService} from "@ispm/test/services/test.service";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";

@Component({
  selector: 'gen-add-sample',
  templateUrl: './add-sample.component.html',
  styleUrls: ['./add-sample.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddSampleComponent implements OnInit, OnDestroy {
  private modalSubscriber$: Subscription;
  private formComponent;
  private revisionId;
  public destroyer$: Subject<any> = new Subject();
  @Input() sampleType: string;
  @Input() addSamplePermitted: boolean;
  @Output() updatedOrder: EventEmitter<any> = new EventEmitter();

  constructor(private dynamicModalLoader: DynamicModalLoaderService, private testActionsService: TestActionsService, private routerManagerService: RouterManagerService,
              private coreActions: CoreActionCreatorService,
              private _ngZone: NgZone,
              private testService: TestService
  ) {
    this.revisionId = routerManagerService.parameters.revisionId;
  }

  ngOnInit() {
    this.testService.loadTestInfoCollections();
    switch (this.sampleType) {
      default: {
        this.formComponent = NavicanSampleFormComponent;
        break;
      }
    }

  }

  openPopup() {
    if (this.modalSubscriber$) { return; }
    this.modalSubscriber$ = this.dynamicModalLoader.popupModal(PlaceholderModalComponent,
      {
        title: 'Add Sample',
        componentToLoad: this.formComponent,
        buttons: {
          approveBtn: 'Save and Add to LIMS',
          declineBtn: 'Cancel',
        },
        approveCallback: (specimen, testId, limsWorkflow, workflowRequestTemplateId) => {
                            this.coreActions.setLoader(true);
                            return this.AddSpecimen(specimen, testId, limsWorkflow, workflowRequestTemplateId);
                          },
      })
      .filter(response => response.payload)
      .map(response => response.payload)
      .subscribe((response: any) => {
        switch (<modalResponse> response.status) {
          case modalResponse.approve:
            this.updatedOrder.emit(response.data);
            break;
          case modalResponse.decline:
          default:
            return false;
        }
      },
        () => {
        },
        () => {
          this._ngZone.runOutsideAngular(() => {
            setTimeout(() => {
              this.coreActions.setLoader(false);
              this.routerManagerService.reload();
            }, 0);
          });
          this.modalSubscriber$.unsubscribe();
          this.modalSubscriber$ = null;
        });
  }

  ngOnDestroy(): void {
    if (this.modalSubscriber$) {
      this.modalSubscriber$.unsubscribe();
    }
    this.destroyer$.complete();
  }

  AddSpecimen(specimen, testId, limsWorkflow, workflowRequestTemplateId) {
    return this.testActionsService.AddSpecimen(specimen, testId, limsWorkflow, this.revisionId, workflowRequestTemplateId);
  }

}
